
// Hamburger Animation
$( ".hamburger" ).click(function() {
  $( this ).toggleClass( "is-active" );
});

$( ".js-nav-control" ).click(function() {
 	$('body').toggleClass('open');
});



	
	// SEARCH 

	 $('.user-icons').on("click", function(e) {
	      $('#search-pop').hide();
	});


	  $("body").on("click", '.js-show-search, .search-close', function(e) {
	    $('.search-close').css('padding-top', $('.header').height() + 100 + 'px')
	    if($('#search-pop').is(":visible") && $(window).scrollTop() == 0) {
	      $(".index .header").removeClass('header_bar');
	      $('.index .header .logo img').attr('src', $('.logo img').data('src-home'));
	    } else {
	      $(".index .header").addClass('header_bar');
	      $('.index .header .logo img').attr('src', $('.logo img').data('src'));
	    }

	    $('#search-pop').fadeToggle('fast').find('input').focus();
	    e.stopPropagation();
	    e.preventDefault();
	  });


	// QTY Adjust
  
	/* JS Quantity Incrementers */
	jQuery(function(){
	  var j = jQuery; 
	  var addInput = '.js-qty-wrap'; 
  
	  j(addInput).each(function() { 
	    var inputEl = j(this).closest(addInput).find('input');
	    var n = inputEl.val(); 
	    var plusEl = j(this).closest(addInput).find('.plus');
	    var minEl = j(this).closest(addInput).find('.min');
	    //On plus click add 1 to n
	    plusEl.on('click', function(){
	      inputEl.val(++n);
	    });
	    //On min click 
	    minEl.on('click', function(){
	    //If n is bigger or equal to 1 subtract 1 from n 
	      if ( ( inputEl.val() ) >= 1) {
	        inputEl.val(--n);
	      } 
	    });
	  });
	});


// PACKS

$('.js-pack-collection').slick({
    slidesToShow: 5,
    slidesToScroll: 5,
	  centerMode: false,
	  centerPadding: '0',
    prevArrow: "<a href='#' class='pack-arrow pack-arrow-prev'><span class='visually-hidden'>Previous</span></a>",
    nextArrow: "<a href='#' class='pack-arrow pack-arrow-next'><span class='visually-hidden'>Next</span></a>",
	responsive: [     
  {
      breakpoint: 1024,
      settings: {
       	slidesToShow: 3,
   		slidesToScroll: 3,
		dots:false,
		arrows:true,
		centerMode: false,
      }
    },
        {
      breakpoint: 768,
      settings: {
       	slidesToShow: 1,
   		slidesToScroll: 2,
		dots:false,
		arrows:false,
		centerMode: false,
      }
    },
    {
      breakpoint: 600,
        centerMode: true,
      	settings: {
        slidesToShow: 1,
		slidesToScroll: 1,
		dots:false,
		arrows:false,
		centerMode: true,
		centerPadding: '60px',

      }
    }
  ]  	
                                 
});

 
// BEST SELLERS	
$('.js-best-sellers').slick({
    slidesToShow: 3,
    slidesToScroll: 3,
	  centerMode: false,
	  centerPadding: '0',
    prevArrow: "<a href='#' class='best-sellers-arrow best-sellers-arrow-prev' role='button' aria-label='Show previous best sellers'><i class='arrow-icon'></i></a>",
    nextArrow: "<a href='#' class='best-sellers-arrow best-sellers-arrow-next' role='button' aria-label='Show next best sellers'><i class='arrow-icon'></i></a>",
	responsive: [     
  {
      breakpoint: 1024,
      settings: {
       	slidesToShow: 2,
   		slidesToScroll: 2,
		dots:false,
		arrows:true,
		centerMode: false,
      }
    },
        {
      breakpoint: 768,
      settings: {
       	slidesToShow: 1,
   		slidesToScroll: 2,
		dots:false,
		arrows:false,
		centerMode: false,
      }
    },
    {
      breakpoint: 600,
        centerMode: true,
      	settings: {
        slidesToShow: 1,
		slidesToScroll: 1,
		dots:false,
		arrows:false,
		centerMode: true,
		centerPadding: '60px',

      }
    }
  ]  	
                                 
});


// VIDEOS

$('.js-video-thumbs').slick({
    slidesToShow: 4,
    slidesToScroll: 4,
	  centerMode: false,
	  centerPadding: '0',
			  arrows:true,
			  dots:false,
    prevArrow: "<a href='#' class='video-thumbs-arrow video-thumbs-arrow-prev'><i class='arrow-icon'></i></a>",
    nextArrow: "<a href='#' class='video-thumbs-arrow video-thumbs-arrow-next'><i class='arrow-icon'></i></a>",
	responsive: [     
  {
      breakpoint: 1280,
      settings: {
       	slidesToShow: 3,
   		slidesToScroll: 3,
		dots:true,
		arrows:false,
		centerMode: false,
	}
      },
	  
	  {
	      breakpoint: 1024,
	      settings: {
	       	slidesToShow: 3,
	   		slidesToScroll: 3,
			dots:true,
			arrows:false,
			centerMode: false,
	      }
    },
        {
      breakpoint: 768,
      settings: {
       	slidesToShow: 1,
   		slidesToScroll: 2,
		dots:true,
		arrows:false,
		centerMode: false,
      }
    },
    {
      breakpoint: 600,
        centerMode: true,
      	settings: {
        slidesToShow: 1,
		slidesToScroll: 1,
		dots:false,
		arrows:false,
		centerMode: true,
		centerPadding: '60px',

      }
    }
  ]  	
                                 
});


 


// PDP CAROUSEL WITH THUMBS
  $('.js-slider-primary').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    infinite:true,
    asNavFor: '.js-slider-thumbs'
  });
  $('.js-slider-thumbs').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: '.js-slider-primary',
    dots: false,
    centerMode: false,
    focusOnSelect: true,
    infinite:true,
    variableWidth: false,
    arrows: true,
    prevArrow: "<a href='#' class='pdp-thumbs-arrow pdp-thumbs-arrow-prev'><i class='arrow-icon'></i></a>",
    nextArrow: "<a href='#' class='pdp-thumbs-arrow pdp-thumbs-arrow-next'><i class='arrow-icon'></i></a>",
  });




$('.js-how-slider').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 4000,
  dots:true,
  arrows:false,
  fade:true,
  appendDots: '.js-how-dots',
});
  


// CHANGE IMAGE WITH VARIANT CHANGE
(function(window, $) {
  $(document).ready(function() { 
    $('body')
    .on('change', '#productSelect', function(event) { 
      // Update Price
      var selected     = this.options[this.selectedIndex],
          variantPrice = selected.dataset.price,
          variantComparePrice = selected.dataset.comparePrice;
      $('#price_material').text(variantPrice);
      var $productGridItem = $(this).closest('.product-grid-item');
      if ($productGridItem.length > 0) {
        $productGridItem.find('.product-price--regular').text(variantComparePrice);
        $productGridItem.find('.product-price--sale').text(variantPrice);
      }

      /** Update image Slider */
      var variantImage = selected.dataset.image;
      var position = -1;

      $('.product-thumbs .single-thumb').each(function() { 
        if ( $(this).data('image') == variantImage ) { 
          position = parseInt($(this).data('slick-index'));
          return;
        }
      });

      if ( position != -1 ) {
        $('.product-thumbs').find('.js-slider-thumbs').slick('slickGoTo', position);
      }


      /** Update Nutritions table tab content */
      if ( this.options.length > 1 && window.product_variants !== undefined ) { 
        product_variants.forEach((variant_meta) => { 
          if ( variant_meta.id == selected.value ) { 
            for (const [key, value] of Object.entries(variant_meta)) { 
              $(`.js-meta-${key}`).empty().html(value);
            }
          }
        });
      }
    })
  })
})(window, jQuery);


// Footer Nav

function resizeHandler() {
  console.log("window resized");

  if ($(window).width() < 767) {
    console.log("window small than 600");
    
    $('.footer-nav ul').hide();
    $('.footer-nav ul').slideUp(200);
  } else{
     $('.footer-nav ul').show();
     $('.footer-nav-header').removeClass("expanded");
  }
 }

resizeHandler();

$(window).resize(resizeHandler);

$('body').on('click', '.footer-nav-header', function() { 
  if ($(window).width() < 767) {
    $(this).next().slideToggle(200);
    $(this).toggleClass("expanded");
  }
});